module.exports = __webpack_public_path__ + "img/lx_02.5f51fff8.jpg";